import {
  ADD_QR_LINK,
  GET_QR_LINK_DETAILS,
  GET_QR_LINKS,
  UPDATE_QR_LINK,
  UPDATE_QR_LINK_STATUS,
  DELETE_QR_LINK,
} from "helpers/url_helper";
import { createCrudSlice } from "./createCrudSlice";

const qrLinksSlice = createCrudSlice({
  name: "qrLinks",
  urls: {
    getList: GET_QR_LINKS,
    getListMethod: "post",
    add: ADD_QR_LINK,
    addMethod: "post",
    update: UPDATE_QR_LINK,
    updateMethod: "put",
    getDetails: GET_QR_LINK_DETAILS,
    updateStatus: UPDATE_QR_LINK_STATUS,
    delete: DELETE_QR_LINK,
  },
  initialFilters: {
    locationName: "",
  },
});

export const { setFilter, resetFilters } = qrLinksSlice.actions;

export const {
  getList: getQrLinks,
  add: addQrLink,
  update: updateQrLink,
  updateStatus: updateQrLinkStatus,
  delete: deleteQrLink,
  getDetails: getQrLinkDetails,
} = qrLinksSlice.thunks;

export default qrLinksSlice.reducer;
